import React from 'react';
import QR_code from '../../../assets/homeImages/home_images/QR_code.png';
import './FooterView.scss';
import { useNavigate } from 'react-router-dom';
import footer_records from  '../../../assets/footer_records.png'

const FooterView = () => {
  const navigate = useNavigate();
  const version = {
    companyName: 'Copyright © 2017-2025 zhiyunshuke.com All Rights Reserved.',
    address: '津ICP备20211001989号',
    title: '天津挚云数字科技有限公司 版权所有',
  };
  const introducelist = {
    address: `地址：天津市河东区远洋国际中心A座25层`,
    phone: '电话:（022）6059 7296',
    mailbox: '联系邮箱: sales@zhiyunshuke.com',
    workingHours: `9:00 - 18:00 ( 工作日 )                                                                            `,
    zipCode: '邮编: 300171',
    mobile: '手机号: 182-2205-9108',
  };
  return (
    <div className="footer">
      <div className="footer-one">
        <div className="footer-one-left">
          <div className="footer-span">{introducelist.address} </div>
          <div className="footer-span">
            <a style={{ color: '#b3b3b3' }} href="tel:022-6059-7296">
              <span>{introducelist.phone}</span>
            </a>{' '}
            &ensp;
            <span className="workingHours">
              {introducelist.workingHours}
            </span>{' '}
          </div>
          <div className="footer-span">{introducelist.mobile} </div>
          <div className="footer-span">{introducelist.mailbox} </div>
          <div className="footer-span">{introducelist.zipCode} </div>
        </div>
        <div className="footer-center">
          <div className="center-one">
            <span id="white" onClick={() => navigate(`/about`)}>
              关于我们
            </span>
            <span onClick={() => navigate(`/about`)}>企业介绍</span>
            <span onClick={() => navigate(`/about`)}>发展历程</span>
            <span onClick={() => navigate(`/about`)}>资质证书</span>
          </div>
          <div className="center-two">
            <span
              id="white"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/solution`)}
            >
              行业解决方案
            </span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/solution/factoring`)}
            >
              保理系统
            </span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/solution/trade`)}
            >
              贸易系统
            </span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/solution/supply`)}
            >
              供应链金融
            </span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/solution/financial/leasing`)}
            >
              融资租赁
            </span>
          </div>
          <div className="center-three">
            <span id="white" onClick={() => navigate('/product/services')}>
              产品服务
            </span>
            <span onClick={() => navigate('/product/services')}>系统服务</span>
            <span onClick={() => navigate('/product/services')}>运营服务</span>
            <span onClick={() => navigate('/product/services')}>定制服务</span>
          </div>
          <div className="center-three">
            <span
              id="white"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/disclaimers', { state: { active: 0 } })}
            >
              免责声明
            </span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/disclaimers', { state: { active: 1 } })}
            >
              隐私协议
            </span>
          </div>
        </div>
        <div className="footer-right">
          <div className="QRcode">
            <img src={QR_code} alt="" />
          </div>
          <p className="official-account">扫码关注公众号</p>
        </div>
      </div>

      <div className="version">
        <span>{version.companyName}</span>
        <a
          style={{ color: '#e9e9e9'}}
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          rel="noreferrer"
        >
          <span className="version-address">{version.address}</span>
        </a>

        <a
          style={{ color: '#e9e9e9' }}
          href="https://beian.mps.gov.cn/#/query/webSearch?code=12010202001082"
          target="_blank"
          rel="noreferrer"
        >
          <span className="version-address" >
            <img src={footer_records} alt="" style={{ width: '12px', height: '12px', marginRight: '4px',  }}/>
            津公网安备12010202001082号
          </span>
        </a>
        <div>{version.title}</div>
      </div>
    </div>
  );
};

export default FooterView;
